module.exports = __webpack_public_path__ + "components/weather-icon/static/daydrizzle-5bc5644bd39031f68bd3ceb803323bb5.svg";